export enum TreasuryOverviewTypeEnum {
  'withdrawal' = 'withdrawal',
  'deposit' = 'deposit',
  'payment' = 'payment',
  'refund' = 'refund',
}
